
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface BugReportScreenshotsProps {
  screenshots: string[];
  onRemove?: (index: number) => void;
}

export function BugReportScreenshots({ screenshots, onRemove }: BugReportScreenshotsProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-4">
      {screenshots.map((url, index) => (
        <div 
          key={index} 
          className="relative rounded-lg overflow-hidden border border-gray-200 shadow-sm group transition-all duration-300 hover:shadow-md"
        >
          <img 
            src={url} 
            alt={`Screenshot ${index + 1}`} 
            className="w-full h-32 object-cover"
          />
          {onRemove && (
            <Button
              type="button"
              variant="destructive"
              size="icon"
              onClick={() => onRemove(index)}
              className="absolute top-2 right-2 h-6 w-6 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            >
              <X className="h-3 w-3" />
              <span className="sr-only">Remove</span>
            </Button>
          )}
        </div>
      ))}
    </div>
  );
}
